import React from 'react';
import {Alert, AlertContext, Form } from '../../components';
import ApiService from '../../services/api.service';

interface IProps { 
    history?: any;
    id?: number;
    caption?: string;
    captionColor?: any;
    buttonCaption?: string;
    successCaption?: string;
    endPointFilter?: string;
    model: any;
    onLoad?: (data: any) => void;
    onError?: (data: any) => void;
    onDeleteBefore?: () => void;
    onDelete?: (data: any) => void;
    delete?: boolean;
    buttonOnBottom?: boolean;
    cardColor?: any;
    cardGradientColor?: any;
    disableAutoBack?: boolean;
    disableBackButton?: boolean;
    disableCard?: boolean;
    children?: React.ReactNode;
}

interface IState {
    endPointFilter: string;
}

export default class BaseDelete extends React.Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);
        this.state = {
            endPointFilter: props.endPointFilter || '',
        }
    }
    
    static contextType = AlertContext;

    private id = () => this.props.id?.toString() || this.props.history?.location.state?.id || '';
    
    private isLoading: boolean = false;
    private isDeleting: boolean = false;
    
    private onDelete = async() => {
        this.isDeleting = true;
        await this.props.onDeleteBefore?.();
        
        ApiService.delete(this.props.model.endPoint + '/', this.id())
        .then(rp => {
            if (rp.Status) {                 
                if (rp.Data) var data = new this.props.model(rp.Data); 
                this.props.onDelete?.(data);
                if (!this.props.successCaption || this.props.successCaption !== ' ') Alert(this.context, this.props.successCaption || 'Data deleted.', 'success');
                if (!this.props.disableAutoBack) {this.props.history?.goBack();}
            } 
            else { this.props.onError && rp.Errors? this.props.onError(rp.Errors) : Alert(this.context, rp.Messages, 'error'); }
            this.isDeleting = false;
        });
    }

    public componentDidMount() { 
        if (this.isLoading) return;
        this.isLoading = true;
        
        ApiService.get<typeof this.props.model>(this.props.model.endPoint + (this.props.endPointFilter || '?populate=*&filters[id]='), this.id()).then(
            (rp) => {
                if (rp.Status) { 
                    const data = rp.Data.length === 0? this.props.model.defaultValue() : new this.props.model(rp.Data[0]); 
                    this.props.onLoad?.(data);
                } 
                else Alert(this.context, rp.Messages, 'error');
                this.isLoading = false;
            }
        );
    }

    public componentDidUpdate= async() => {
        if (!this.isLoading)
            if (this.props.endPointFilter && this.state.endPointFilter !== this.props.endPointFilter) {
                this.setState({endPointFilter: this.props.endPointFilter})
                this.componentDidMount();
            }
        if (this.props.delete && !this.isDeleting && this.isLoading) this.onDelete();
    }

    render() {
        return(
            <Form history={this.props.history} caption={this.props.caption || 'Delete ' + this.props.model.caption} captionColor={this.props.captionColor} buttonCaption={this.props.buttonCaption || 'delete'} buttonColor='error' buttonOnBottom={this.props.buttonOnBottom} onSubmit={this.onDelete} cardColor={this.props.cardColor} cardGradientColor={this.props.cardGradientColor} disableBackButton={this.props.disableBackButton} disableCard={this.props.disableCard}>              
                {this.props.children}
            </Form>
        );
    }     
}